namespace $ {
	export class $my_habrcomment extends $mol_page {
		
		/**
		 * ```tree
		 * attr * tabindex 0
		 * ```
		 */
		attr() {
			return {
				tabindex: 0
			}
		}
		
		/**
		 * ```tree
		 * head /
		 * 	<= Orig
		 * 	<= Tools
		 * ```
		 */
		head() {
			return [
				this.Orig(),
				this.Tools()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * tools /
		 * 	<= Lights
		 * 	<= Sources
		 * 	<= Search
		 * ```
		 */
		tools() {
			return [
				this.Lights(),
				this.Sources(),
				this.Search()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * body / <= Content
		 * ```
		 */
		body() {
			return [
				this.Content()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * Comment* $my_habrcomment_comment
		 * 	id <= id*
		 * 	time <= comment_time*
		 * 	user_name <= comment_user*
		 * 	user_avatar <= comment_avatar*
		 * 	message <= comment_message*
		 * 	replies <= comments*
		 * 	expanded?val <=> comment_expanded*?val
		 * 	expandable <= comment_expandable*
		 * 	search <= search
		 * 	image_uri* <= image_uri*
		 * ```
		 */
		@ $mol_mem_key
		Comment(id: any) {
			const obj = new this.$.$my_habrcomment_comment()
			
			obj.id = () => this.id(id)
			obj.time = () => this.comment_time(id)
			obj.user_name = () => this.comment_user(id)
			obj.user_avatar = () => this.comment_avatar(id)
			obj.message = () => this.comment_message(id)
			obj.replies = () => this.comments(id)
			obj.expanded = (val?: any) => this.comment_expanded(id, val)
			obj.expandable = () => this.comment_expandable(id)
			obj.search = () => this.search()
			obj.image_uri = (id: any) => this.image_uri(id)
			
			return obj
		}
		
		/**
		 * ```tree
		 * plugins /
		 * 	<= Theme
		 * 	<= Search_start_1
		 * 	<= Search_start_2
		 * ```
		 */
		plugins() {
			return [
				this.Theme(),
				this.Search_start_1(),
				this.Search_start_2()
			] as readonly any[]
		}
		
		/**
		 * ```tree
		 * orig_uri \
		 * ```
		 */
		orig_uri() {
			return ""
		}
		
		/**
		 * ```tree
		 * title \
		 * ```
		 */
		title() {
			return ""
		}
		
		/**
		 * ```tree
		 * Orig $mol_link_iconed
		 * 	uri <= orig_uri
		 * 	title <= title
		 * 	hint \Оригинальная статья
		 * ```
		 */
		@ $mol_mem
		Orig() {
			const obj = new this.$.$mol_link_iconed()
			
			obj.uri = () => this.orig_uri()
			obj.title = () => this.title()
			obj.hint = () => "Оригинальная статья"
			
			return obj
		}
		
		/**
		 * ```tree
		 * Lights $mol_lights_toggle
		 * ```
		 */
		@ $mol_mem
		Lights() {
			const obj = new this.$.$mol_lights_toggle()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Sources $mol_link_source uri \https://github.com/nin-jin/habrcomment
		 * ```
		 */
		@ $mol_mem
		Sources() {
			const obj = new this.$.$mol_link_source()
			
			obj.uri = () => "https://github.com/nin-jin/habrcomment"
			
			return obj
		}
		
		/**
		 * ```tree
		 * search?val \
		 * ```
		 */
		@ $mol_mem
		search(val?: any) {
			if ( val !== undefined ) return val as never
			return ""
		}
		
		/**
		 * ```tree
		 * Search $mol_search_jumper
		 * 	query?val <=> search?val
		 * 	Root <= Body
		 * ```
		 */
		@ $mol_mem
		Search() {
			const obj = new this.$.$mol_search_jumper()
			
			obj.query = (val?: any) => this.search(val)
			obj.Root = () => this.Body()
			
			return obj
		}
		
		/**
		 * ```tree
		 * article_content \
		 * ```
		 */
		article_content() {
			return ""
		}
		
		/**
		 * ```tree
		 * image_uri* \
		 * ```
		 */
		image_uri(id: any) {
			return ""
		}
		
		/**
		 * ```tree
		 * Article $mol_html_view
		 * 	html <= article_content
		 * 	highlight <= search
		 * 	image_uri* <= image_uri*
		 * ```
		 */
		@ $mol_mem
		Article() {
			const obj = new this.$.$mol_html_view()
			
			obj.html = () => this.article_content()
			obj.highlight = () => this.search()
			obj.image_uri = (id: any) => this.image_uri(id)
			
			return obj
		}
		
		/**
		 * ```tree
		 * root_comments /$mol_view
		 * ```
		 */
		root_comments() {
			return [
			] as readonly $mol_view[]
		}
		
		/**
		 * ```tree
		 * Comments_empty $mol_view sub / \Без комментариев
		 * ```
		 */
		@ $mol_mem
		Comments_empty() {
			const obj = new this.$.$mol_view()
			
			obj.sub = () => [
				"Без комментариев"
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * Comments $mol_list
		 * 	rows <= root_comments
		 * 	Empty <= Comments_empty
		 * ```
		 */
		@ $mol_mem
		Comments() {
			const obj = new this.$.$mol_list()
			
			obj.rows = () => this.root_comments()
			obj.Empty = () => this.Comments_empty()
			
			return obj
		}
		
		/**
		 * ```tree
		 * Content $mol_list rows /
		 * 	<= Article
		 * 	<= Comments
		 * ```
		 */
		@ $mol_mem
		Content() {
			const obj = new this.$.$mol_list()
			
			obj.rows = () => [
				this.Article(),
				this.Comments()
			] as readonly any[]
			
			return obj
		}
		
		/**
		 * ```tree
		 * id* \
		 * ```
		 */
		id(id: any) {
			return ""
		}
		
		/**
		 * ```tree
		 * comment_time* $mol_time_moment
		 * ```
		 */
		@ $mol_mem_key
		comment_time(id: any) {
			const obj = new this.$.$mol_time_moment()
			
			return obj
		}
		
		/**
		 * ```tree
		 * comment_user* \
		 * ```
		 */
		comment_user(id: any) {
			return ""
		}
		
		/**
		 * ```tree
		 * comment_avatar* \
		 * ```
		 */
		comment_avatar(id: any) {
			return ""
		}
		
		/**
		 * ```tree
		 * comment_message* \
		 * ```
		 */
		comment_message(id: any) {
			return ""
		}
		
		/**
		 * ```tree
		 * comments* /$mol_view
		 * ```
		 */
		comments(id: any) {
			return [
			] as readonly $mol_view[]
		}
		
		/**
		 * ```tree
		 * comment_expanded*?val true
		 * ```
		 */
		@ $mol_mem_key
		comment_expanded(id: any, val?: any) {
			if ( val !== undefined ) return val as never
			return true
		}
		
		/**
		 * ```tree
		 * comment_expandable* false
		 * ```
		 */
		comment_expandable(id: any) {
			return false
		}
		
		/**
		 * ```tree
		 * Theme $mol_theme_auto
		 * ```
		 */
		@ $mol_mem
		Theme() {
			const obj = new this.$.$mol_theme_auto()
			
			return obj
		}
		
		/**
		 * ```tree
		 * search_focus?event null
		 * ```
		 */
		@ $mol_mem
		search_focus(event?: any) {
			if ( event !== undefined ) return event as never
			return null as any
		}
		
		/**
		 * ```tree
		 * Search_start_1 $mol_hotkey
		 * 	mod_ctrl true
		 * 	key * F?event <=> search_focus?event
		 * ```
		 */
		@ $mol_mem
		Search_start_1() {
			const obj = new this.$.$mol_hotkey()
			
			obj.mod_ctrl = () => true
			obj.key = () => ({
				F: (event?: any) => this.search_focus(event)
			})
			
			return obj
		}
		
		/**
		 * ```tree
		 * Search_start_2 $mol_hotkey key * F3?event <=> search_focus?event
		 * ```
		 */
		@ $mol_mem
		Search_start_2() {
			const obj = new this.$.$mol_hotkey()
			
			obj.key = () => ({
				F3: (event?: any) => this.search_focus(event)
			})
			
			return obj
		}
	}
	
}

